import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetLogsQuery } from "../store/slices/settingsSlice";
import { faRotateBack } from "@fortawesome/free-solid-svg-icons";
import MyPagination from "../Common/MyPagination";
import MyModal from "../Common/MyModal";
import { Link, useLocation } from "react-router-dom";

export default function Logs({ kind, level, resource }) {
  const [paginations, setPaginations] = useState({ offset: 0, limit: 12 });
  const { data, refetch } = useGetLogsQuery({
    ...paginations,
    kind,
    level,
    resource,
  });
  const location = useLocation();

  return (
    <div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-link" onClick={() => refetch()}>
          <FontAwesomeIcon icon={faRotateBack} />
        </button>
      </div>
      {!!data?.total ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Id</th>
              <th>User</th>
              <th>Created at</th>
              <th>Level</th>
              {!kind && <th>Kind</th>}
              <th>Message</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {data?.logs?.map((item, i) => (
              <tr key={item.Id}>
                <td>{item.Id} </td>
                <td>{item.User} </td>
                <td>{new Date(item.CreatedAt).toLocaleString()} </td>
                <td>{item.Level} </td>
                {!kind && (
                  <td>
                    {item.Kind === "api_connection" ? (
                      <Link
                        to={`/library/api-connections/${item.Resource}/details`}
                        state={{ previousLocationPathname: location.pathname }}
                      >
                        API Connection
                      </Link>
                    ) : item.Kind === "monitor" ? (
                      <Link
                        to={`/monitoring/${item.Resource}`}
                        state={{ previousLocationPathname: location.pathname }}
                      >
                        Monitor
                      </Link>
                    ) : item.Kind === "contact" ? (
                      <Link
                        to={`/assets/contacts/edit/${item.Resource}`}
                        state={{ previousLocationPathname: location.pathname }}
                      >
                        Contact
                      </Link>
                    ) : item.Kind === "group" ? (
                      <Link
                        to={`/assets/contacts/groups/${item.Resource}`}
                        state={{ previousLocationPathname: location.pathname }}
                      >
                        Contact Group
                      </Link>
                    ) : (
                      ` ${item.Kind} - ${item.Resource} `
                    )}
                  </td>
                )}
                <td>{item.Message} </td>
                <td>
                  {item.Data ? (
                    <MyModal
                      heading="Log Data"
                      label="View Data"
                      size="lg"
                      buttonClassName="btn-secondary px-1"
                    >
                      <div className="my-3">
                        <pre>{JSON.stringify(item.Data, null, 2)}</pre>
                      </div>
                    </MyModal>
                  ) : (
                    "{}"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div className="alert alert-warning text-center">
          No logs found.
        </div>
      )}
      <MyPagination
        onPaginate={(page, perPage) => {
          setPaginations({ offset: page * perPage, limit: perPage });
        }}
        total={data?.total || 0}
      />
    </div>
  );
}
